// extracted by mini-css-extract-plugin
module.exports = {"name":"adv-post-form_name__4Ww8J","percent":"adv-post-form_percent__WxWks","boostMax":"adv-post-form_boostMax___xi9X"};